export const initMapaContacto = () => {
  const section = document.querySelector('.mapa-contacto');
  if (!section) return;

  const trigger = section.querySelector('.mapa-contacto__trigger');
  const iframeWrap = section.querySelector('.mapa-contacto__iframe-wrap');
  const iframe = section.querySelector('.mapa-contacto__iframe');
  const closeBtn = section.querySelector('.mapa-contacto__close');

  const activate = () => {
    if (!iframe.getAttribute('src')) {
      iframe.src = iframe.dataset.src;
    }
    section.classList.add('is-active');
    iframeWrap.removeAttribute('aria-hidden');
    iframe.removeAttribute('tabindex');
    closeBtn?.focus();
  };

  const deactivate = () => {
    section.classList.remove('is-active');
    iframeWrap.setAttribute('aria-hidden', 'true');
    iframe.setAttribute('tabindex', '-1');
    trigger?.focus();
  };

  trigger?.addEventListener('click', activate);
  trigger?.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      activate();
    }
  });

  closeBtn?.addEventListener('click', deactivate);
};
